import { GlButton, GlIcon, GlSkeletonLoader, GlLink, GlTooltipDirective, GlAnimatedChevronLgDownUpIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'CrudComponent',
    components: {
        GlButton,
        GlIcon,
        GlSkeletonLoader,
        GlLink,
        GlAnimatedChevronLgDownUpIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        description: {
            type: String,
            required: false,
            default: null
        },
        count: {
            type: [
                String,
                Number
            ],
            required: false,
            default: ''
        },
        icon: {
            type: String,
            required: false,
            default: null
        },
        toggleText: {
            type: String,
            required: false,
            default: null
        },
        toggleAriaLabel: {
            type: String,
            required: false,
            default: null
        },
        isCollapsible: {
            type: Boolean,
            required: false,
            default: false
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false
        },
        containerTag: {
            type: String,
            required: false,
            default: 'section'
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        anchorId: {
            type: String,
            required: false,
            default: ''
        },
        headerClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: null
        },
        titleContainerClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: null
        },
        titleClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: null
        },
        titleTag: {
            type: String,
            required: false,
            default: 'h2',
            validator: (value)=>[
                    'h1',
                    'h2',
                    'h3',
                    'h4',
                    'h5',
                    'h6',
                    'div'
                ].includes(value)
        },
        actionsContainerClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: null
        },
        bodyClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: null
        },
        footerClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: null
        },
        persistCollapsedState: {
            type: Boolean,
            required: false,
            default: false
        },
        showZeroCount: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'click-collapsed',
        'click-expanded',
        'collapsed',
        'expanded',
        'hide-form',
        'show-form'
    ],
    data () {
        return {
            isCollapsed: this.collapsed && !this.persistCollapsedState || this.persistCollapsedState && localStorage.getItem(this.getLocalStorageKeyName()) === 'true',
            isFormVisible: false
        };
    },
    computed: {
        isContentVisible () {
            return !(this.isCollapsible && this.isCollapsed);
        },
        toggleLabel () {
            return this.isCollapsed ? __('Expand') : __('Collapse');
        },
        ariaExpandedAttr () {
            return this.isCollapsed ? 'false' : 'true';
        },
        displayedCount () {
            if (this.isLoading) {
                return null;
            }
            if (this.count) {
                return this.count;
            }
            if (this.icon || this.showZeroCount) {
                return '0';
            }
            return null;
        },
        isFormUsedAndVisible () {
            return this.glSlots().form && this.isFormVisible && !this.isCollapsed;
        }
    },
    watch: {
        collapsed: {
            handler (newVal) {
                this.isCollapsed = newVal > 0;
            }
        }
    },
    mounted () {
        const localStorageValue = localStorage.getItem(this.getLocalStorageKeyName());
        if (this.persistCollapsedState) {
            // If collapsed by default and not yet toggled.
            if (this.collapsed && localStorageValue === null) {
                this.isCollapsed = true;
            }
            if (localStorageValue === 'true') {
                this.$emit('collapsed');
            } else if (localStorageValue) {
                this.$emit('expanded');
            }
        }
    },
    methods: {
        toggleCollapse () {
            this.isCollapsed = !this.isCollapsed;
            if (this.isCollapsed) {
                this.$emit('collapsed');
                /**
         * note that these separate `click-*` emits are necessary for tracking
         * this because the expanded and collapsed emits are programmatically
         * called on mount as part of persisted collapse state management. If
         * we just used the existing emits we would get tons of false positives
         * on page loads.
         */ this.$emit('click-collapsed');
            } else {
                this.$emit('expanded');
                /**
         * note that these separate `click-*` emits are necessary for tracking
         * this because the expanded and collapsed emits are programmatically
         * called on mount as part of persisted collapse state management. If
         * we just used the existing emits we would get tons of false positives
         * on page loads.
         */ this.$emit('click-expanded');
            }
            if (this.persistCollapsedState) {
                localStorage.setItem(this.getLocalStorageKeyName(), this.isCollapsed);
            }
        },
        showForm () {
            this.isFormVisible = true;
            this.isCollapsed = false;
            this.$emit('show-form');
        },
        hideForm () {
            this.isFormVisible = false;
            this.$emit('hide-form');
        },
        getLocalStorageKeyName () {
            return `crud-collapse-${this.anchorId}`;
        }
    }
};
